import React, { useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as AddressImg } from "../../assets/svg/address.svg";

const Address = () => {
    const [isLinkHovered, setIsLinkHovered] = useState(false);

    const handleLinkMouseOver = () => {
      setIsLinkHovered(true);
    };

    const handleLinkMouseLeave = () => {
      setIsLinkHovered(false);
    };
  return (
    <AddressWrap>
      <AddressImg className='addSvg' />
      <div className='addTxtBox'>
      <a onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link' : ''}
        href="###">info@topping.io</a>
      <h2 onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link title' : 'title'}>
        1304, 121, Digital-ro, Geumcheon-gu <br />
        Seoul, Republic of Korea
      </h2>
      <p  onMouseOver={handleLinkMouseOver}
        onMouseLeave={handleLinkMouseLeave}
        className={isLinkHovered ? 'hovered-link introText' : 'introText'}>
        서울 특별시 금천구 가산디지털로 121. 에이스 가산타워 1304호
      </p>
      </div>
      
    </AddressWrap>
  );
};

const AddressWrap = styled.div`
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-bottom:-50px;
  padding-left:100px;
  position: relative;
  .addTxtBox{
    position: relative;
    text-align: left;
  }
  .addSvg{
    position: absolute;
    left: 50%;
    top:50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    
    path{
      opacity:0.1;
      animation: opacityAni 2.2s infinite;
      transition: opacity 1s;
    }
      path:nth-child(1) { animation-delay: 0.1s; }
      path:nth-child(2) { animation-delay: 0.2s; }
      path:nth-child(3) { animation-delay: 0.3s; }
      path:nth-child(4) { animation-delay: 0.4s; }
      path:nth-child(5) { animation-delay: 0.5s; }
      path:nth-child(6) { animation-delay: 0.6s; }
      path:nth-child(7) { animation-delay: 0.7s; }
      path:nth-child(8) { animation-delay: 0.8s; }
      path:nth-child(9) { animation-delay: 0.9s; }
      path:nth-child(10) { animation-delay: 1s; }
      path:nth-child(11) { animation-delay: 1.1s; }
      path:nth-child(12) { animation-delay: 1.2s; }
      path:nth-child(13) { animation-delay: 1.3s; }
      path:nth-child(14) { animation-delay: 1.4s; }
      path:nth-child(15) { animation-delay: 1.5s; }
      path:nth-child(16) { animation-delay: 1.6s; }
      path:nth-child(17) { animation-delay: 1.7s; }
      path:nth-child(18) { animation-delay: 1.8s; }
      path:nth-child(19) { animation-delay: 1.9s; }
      path:nth-child(20) { animation-delay: 2s; }
      path:nth-child(21) { animation-delay: 2.1s; }
      path:nth-child(22) { animation-delay: 2.2s; }
  }
      @keyframes opacityAni {
      0% {
        opacity: 0.1;
      }
      100% {
        opacity:1;
      }
    }

  a{
    color:#000;
    font-size: 80px;
    font-weight: 700;
    line-height: 120.9%
  }
  .title{
    color:#000;  
    margin:60px 0 50px;  
  }
  .introText{
    color:#000;   
    font-size:20px; 
    text-align: left;
  }
`;

export default Address;